__turbopack_context__.v({
  "inputs-group": "MobileOnboardingInputs-module-scss-module__yVay7G__inputs-group",
  "inputs-section": "MobileOnboardingInputs-module-scss-module__yVay7G__inputs-section",
  "inputs-section-header": "MobileOnboardingInputs-module-scss-module__yVay7G__inputs-section-header",
  "inputs-section-header-container": "MobileOnboardingInputs-module-scss-module__yVay7G__inputs-section-header-container",
  "next-button-container": "MobileOnboardingInputs-module-scss-module__yVay7G__next-button-container",
});
